import { combineStateReducer } from "../utils/combineStateReducer";
import { State, Selector } from "./types";

import * as configureProjectTools from "./configureProjectTools";
import * as createProject from "./createProject";
import * as editProject from "./editProject";
import * as editProjectWeatherReport from "./editProjectWeatherReport";
import * as pushProjectHistory from "./pushProjectHistory";
import * as removeProject from "./removeProject";
import * as retrieveProject from "./retrieveProject";
import * as retrieveProjectHistory from "./retrieveProjectHistory";
import * as retrieveProjects from "./retrieveProjects";
import * as retrieveProjectSynthesis from "./retrieveProjectSynthesis";
import * as retrieveProjectToolsConfiguration from "./retrieveProjectToolsConfiguration";
import * as retrieveProjectModels from "./retrieveProjectModels";
import * as useProjectModel from "./useProjectModel";
import * as createProjectModelFromProject from "./createProjectModelFromProject";
import * as duplicateProject from "./duplicateProject";

const initialState: State = {
  configureProjectTools: configureProjectTools.initialState,
  createProject: createProject.initialState,
  editProject: editProject.initialState,
  editProjectWeatherReport: editProjectWeatherReport.initialState,
  pushProjectHistory: pushProjectHistory.initialState,
  removeProject: removeProject.initialState,
  retrieveProject: retrieveProject.initialState,
  retrieveProjectHistory: retrieveProjectHistory.initialState,
  retrieveProjects: retrieveProjects.initialState,
  retrieveProjectSynthesis: retrieveProjectSynthesis.initialState,
  retrieveProjectToolsConfiguration:
    retrieveProjectToolsConfiguration.initialState,
  retrieveProjectModels: retrieveProjectModels.initialState,
  useProjectModel: useProjectModel.initialState,
  createProjectModelFromProject: createProjectModelFromProject.initialState,
  duplicateProject: duplicateProject.initialState,
};

const reduceState = combineStateReducer(initialState, {
  configureProjectTools: configureProjectTools.reduceState,
  createProject: createProject.reduceState,
  editProject: editProject.reduceState,
  editProjectWeatherReport: editProjectWeatherReport.reduceState,
  pushProjectHistory: pushProjectHistory.reduceState,
  removeProject: removeProject.reduceState,
  retrieveProject: retrieveProject.reduceState,
  retrieveProjectHistory: retrieveProjectHistory.reduceState,
  retrieveProjects: retrieveProjects.reduceState,
  retrieveProjectSynthesis: retrieveProjectSynthesis.reduceState,
  retrieveProjectToolsConfiguration:
    retrieveProjectToolsConfiguration.reduceState,
  retrieveProjectModels: retrieveProjectModels.reduceState,
  useProjectModel: useProjectModel.reduceState,
  createProjectModelFromProject: createProjectModelFromProject.reduceState,
  duplicateProject: duplicateProject.reduceState,
});

function createSelector(getState: () => State): Selector {
  return {
    ...configureProjectTools.createSelector(
      () => getState().configureProjectTools,
    ),
    ...createProject.createSelector(() => getState().createProject),
    ...editProject.createSelector(() => getState().editProject),
    ...editProjectWeatherReport.createSelector(
      () => getState().editProjectWeatherReport,
    ),
    ...pushProjectHistory.createSelector(() => getState().pushProjectHistory),
    ...removeProject.createSelector(() => getState().removeProject),
    ...retrieveProject.createSelector(() => getState().retrieveProject),
    ...retrieveProjectHistory.createSelector(
      () => getState().retrieveProjectHistory,
    ),
    ...retrieveProjects.createSelector(() => getState().retrieveProjects),
    ...retrieveProjectSynthesis.createSelector(
      () => getState().retrieveProjectSynthesis,
    ),
    ...retrieveProjectToolsConfiguration.createSelector(
      () => getState().retrieveProjectToolsConfiguration,
    ),
    ...retrieveProjectModels.createSelector(
      () => getState().retrieveProjectModels,
    ),
    ...useProjectModel.createSelector(() => getState().useProjectModel),
    ...createProjectModelFromProject.createSelector(
      () => getState().createProjectModelFromProject,
    ),
    ...duplicateProject.createSelector(() => getState().duplicateProject),
  };
}

export type { State, Selector };

export { reduceState, initialState, createSelector };
